import { Modal, Button } from '@prosolve/common-components-ui'

export default ({
  title = '',
  text = '',
  subText = 'Do you wish to proceed?',
  onClose,
  onSubmit
}) => {

  const footer = (
    <div style={{ 
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
      columnGap: '10px',
      padding: '10px'
    }}>
      <Button onClick={onClose}>
        {'Cancel'}
      </Button>
      <Button onClick={onSubmit} $colored={true}>
        {'Continue'}
      </Button>
    </div>
  )

  return (
    <Modal title={title} isAutoHeight={true} onClose={onClose} footer={footer}>
      <div style={{
        display: 'flex',
        flexDirection: 'column'
      }}>
        <div>
          {text}
        </div>
        <div style={{ marginTop: '40px'}}>
          {subText}
        </div>
      </div>
    </Modal>
  )
}